// import { createStore, combineReducers, applyMiddleware } from "redux";
// import AuthReducer from "../store/reducers/Auth";
// import leftNavLinksReducer from "../store/reducers/leftNavLinks";
// import groupsReducer from "../store/reducers/Groups";
// import meetingCRUDReducer from "../store/reducers/Meetings";
// import ApprovalsReducer from "../store/reducers/Approvals";
// import EvaluationsReducer from "../store/reducers/Evaluations";
// import ResourcesReducer from "../store/reducers/Resources";
// import SystemUtilitiesReducer from "../store/reducers/SystemUtilities";
// import EventsReducer from "../components/Content/Dashboard/store/reducer";
// import LanguageReducers from "../store/reducers/LanguageReducers";
// import DrawerReducer from "../store/reducers/DrawerReducers";
// import BudgetsReducer from "../store/reducers/Budgets";
// import OthersReducer from "../store/reducers/Others";
// import { persistStore, persistReducer } from 'redux-persist'
// import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
// import logger from "redux-logger";
// //import { DEV_ENVIRONMENT } from "../constants";

// // const persistConfig = {
// //     key: 'root',
// //     storage,
// //   }

// const reducer = combineReducers({
//   auth: AuthReducer,
//   leftNavLinks: leftNavLinksReducer,
//   groups: groupsReducer,
//   meetingCRUD: meetingCRUDReducer,
//   approvals: ApprovalsReducer,
//   evaluations: EvaluationsReducer,
//   resources: ResourcesReducer,
//   utilities: SystemUtilitiesReducer,
//   events: EventsReducer,
//   languages: LanguageReducers,
//   drawer: DrawerReducer,
//   budgets: BudgetsReducer,
//   others: OthersReducer,
// });

// // const persistedReducer = persistReducer(persistConfig, reducer)

// export const store = process.env.REACT_APP_DEV_ENVIRONMENT === "localhost"
//   ? createStore(reducer, applyMiddleware(logger))
//   : createStore(reducer);
// // export const store = createStore(reducer);
// // export const persistor = persistStore(store)

import { createStore, combineReducers, applyMiddleware } from "redux";
import AuthReducer from "../store/reducers/Auth";
import leftNavLinksReducer from "../store/reducers/leftNavLinks";
import groupsReducer from "../store/reducers/Groups";
import meetingCRUDReducer from "../store/reducers/Meetings";
import ApprovalsReducer from "../store/reducers/Approvals";
import EvaluationsReducer from "../store/reducers/Evaluations";
import ResourcesReducer from "../store/reducers/Resources";
import SystemUtilitiesReducer from "../store/reducers/SystemUtilities";
import EventsReducer from "../components/Content/Dashboard/store/reducer";
import LanguageReducers from "../store/reducers/LanguageReducers";
import DrawerReducer from "../store/reducers/DrawerReducers";
import BudgetsReducer from "../store/reducers/Budgets";
import OthersReducer from "../store/reducers/Others";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import logger from "redux-logger";

// ✅ UNCOMMENT AND CONFIGURE THIS - Only persist auth
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'] // ✅ Only persist auth reducer (not utilities, meetings, etc.)
};

const reducer = combineReducers({
    auth: AuthReducer,
    leftNavLinks: leftNavLinksReducer,
    groups: groupsReducer,
    meetingCRUD: meetingCRUDReducer,
    approvals: ApprovalsReducer,
    evaluations: EvaluationsReducer,
    resources: ResourcesReducer,
    utilities: SystemUtilitiesReducer,
    events: EventsReducer,
    languages: LanguageReducers,
    drawer: DrawerReducer,
    budgets: BudgetsReducer,
    others: OthersReducer,
});


const persistedReducer = persistReducer(persistConfig, reducer);

// Use persistedReducer instead of reducer
export const store = process.env.REACT_APP_DEV_ENVIRONMENT === "localhost"
    ? createStore(persistedReducer, applyMiddleware(logger))
    : createStore(persistedReducer);

export const persistor = persistStore(store);